module.exports = __webpack_public_path__ + "static/media/14.78b0c328.svg";